import * as crypto from "node:crypto";

/**
 *
 * @param inString - string to hash
 * @param trimLength - trim to this length (defaults to 999 chars)
 * @returns Hex-encoded sha256 digest, truncated to `trimLength` characters.
 */
export const hashString = (inString: string, trimLength: number = 999) => {
  return crypto
    .createHash("sha256")
    .update(inString)
    .digest("hex")
    .substring(0, trimLength);
};

/**
 *
 * @param inputString - string to truncate
 * @param maxLength - max length of this string
 * @returns trimmed string
 */
export const trimStringLength = (inputString: string, maxLength: number) => {
  return inputString.length < maxLength
    ? inputString
    : inputString.substring(0, maxLength);
};
